import AssetDisplay from "./AssetDisplay";

export default AssetDisplay;
